(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
class collectionGridBanner extends HTMLElement {
    constructor() {
        super();
        this.products = document.querySelectorAll('.product-grid .product-block');
        this.desktopPosition = parseInt(this.dataset.position) || 0;
        this.mobilePosition = parseInt(this.dataset.mobilePosition) || this.desktopPosition;
        this.bannerContent = this.querySelector('.collection_grid_banner');
        
        // Initial placement
        this.placeBanner();
        
        // Add resize listener
        this.resizeHandler = this.handleResize.bind(this);
        window.addEventListener('resize', this.resizeHandler);
    }
    
    placeBanner() {
        if (!this.products.length || !this.bannerContent) return;
        
        // Determine current position based on screen width
        const position = window.innerWidth < 600 ? this.mobilePosition : this.desktopPosition;
        
        // Get current banner location if it's already in the DOM
        let currentIndex = -1;
        if (this.bannerContent.parentNode) {
            const productBlocks = Array.from(this.products);
            const parentIndex = productBlocks.findIndex(product => 
                product.nextElementSibling === this.bannerContent);
            if (parentIndex !== -1) currentIndex = parentIndex + 1;
        }
        
        // If position is valid and different from current position, move the banner
        if (position > 0 && position !== currentIndex) {
            for (let i = 0; i < this.products.length; i++) {
                if (i + 1 === position) {
                    this.products[i].parentNode.insertBefore(this.bannerContent, this.products[i].nextSibling);
                    break;
                }
            }
        }
    }
    
    handleResize() {
        this.placeBanner();
    }
    
    disconnectedCallback() {
        // Clean up event listener when component is removed
        window.removeEventListener('resize', this.resizeHandler);
    }
}
customElements.define('grid-banner', collectionGridBanner);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
